<template>
    <div>
        <el-dialog title="查看异常导入数据" :visible.sync="data.visible" :close-on-click-modal="false" :append-to-body="true" :width="'70%'">
            <el-table size="mini" :data="data.errorReport.rows" fit highlight-current-row style="width: 100%;" class="import-error-report">
                <template v-for="(header,index) in data.errorReport.header">
                    <el-table-column :key="header.name" :label="header">
                        <template slot-scope="{row}">
                            <span>{{row[index].value}}</span>
                            <template v-if="row[index].errors">
                                <ul class="error">
                                    <li v-for="error in row[index].errors" :key="error.message"><i class="el-icon-error"></i> {{error.message}}</li>
                                </ul>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="data.visible = false" type="primary">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "DlgImportErrorReport",
    props: ["data"],
};
</script>
<style lang="less" scoped>
.import-error-report {
    .error {
        li {
            color: red;
        }
    }
}
</style>